'use client';

import React from 'react';
import { Image } from '@/components/ui/Image';
import { StaggeredText } from '@/components/ui/StaggeredText';
import {
  TypographyH2,
  TypographyH3,
  TypographySmall,
} from '@/components/ui/typography';
import { SOCIAL_MEDIA } from '@/components/ui/Footer/consts';
import { cls } from '@/lib/utils';
import SectionBase from '../section-base';

const SECTION_ID = 'get-in-touch';
const HERO_IMG = 'projects/Willow/005-19474PecanRidgeLane-Claremore-OK-74017-SMALL_cqhoer';

function GetInTouchSection() {
  return (
    <SectionBase
      id={SECTION_ID}
      containerProps={{ id: SECTION_ID }}
      background="bg-card"
    >
      <div className={cls`flex flex-col gap-10`}>
        {/* Main content: Left image + Right contact info */}
        <div className={cls`flex flex-col md:flex-row gap-10`}>
          {/* Left: Title + Image */}
          <div className="flex-1 flex flex-col items-center gap-6">
            <TypographyH2 className="text-center border-b-0">
              <StaggeredText staggerChildren={0.03} delay={0.1}>
                Cornerstone Homes and Properties
              </StaggeredText>
            </TypographyH2>

            <Image
              src={HERO_IMG}
              alt="Cornerstone Homes custom home"
              fill
              sizes="(max-width: 768px) 100vw, 50vw"
              className="rounded-lg object-cover"
              wrapperClassName="aspect-4/3 relative w-full h-auto"
              style={{ objectFit: 'cover', aspectRatio: '4/3' }}
            />
          </div>

          {/* Right: Contact details */}
          <div className="flex-1 flex flex-col gap-8">
            {/* Contact Us */}
            <div className="flex flex-col gap-3">
              <TypographyH3 className="font-prata">Contact Us</TypographyH3>
              <div className="flex flex-col gap-1">
                <TypographySmall>16380 E 430 Rd.</TypographySmall>
                <TypographySmall>Claremore OK, 74017</TypographySmall>
                <TypographySmall>
                  <a href="tel:918-344-1731" className="hover:underline">
                    918-344-1731
                  </a>
                </TypographySmall>
                <TypographySmall>
                  <a
                    href="https://www.cornerstonehomesok.com"
                    className="hover:underline"
                  >
                    cornerstonehomesok.com
                  </a>
                </TypographySmall>
                <TypographySmall>
                  <a
                    href="mailto:craig@cornerstonehomesok.com"
                    className="hover:underline"
                  >
                    craig@cornerstonehomesok.com
                  </a>
                </TypographySmall>
              </div>
            </div>

            {/* Business Hours */}
            <div className="flex flex-col gap-3">
              <TypographyH3 className="font-prata">Business Hours</TypographyH3>
              <div className="flex gap-8">
                <div className="flex flex-col gap-1">
                  <TypographySmall className="font-semibold">
                    Monday to Friday
                  </TypographySmall>
                  <TypographySmall>9:00 am to 5:00 pm</TypographySmall>
                </div>
                <div className="flex flex-col gap-1">
                  <TypographySmall className="font-semibold">
                    Saturday
                  </TypographySmall>
                  <TypographySmall>By appointment</TypographySmall>
                </div>
              </div>
            </div>

            {/* Get Social */}
            <div className="flex flex-col gap-3">
              <TypographyH3 className="font-prata">Get Social</TypographyH3>
              <div className="flex gap-4">
                {SOCIAL_MEDIA.map(social => (
                  <a
                    key={social.name}
                    href={social.uri}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.name}
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    {social.render({ size: 28 })}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom tagline */}
        <TypographyH2 className="text-center border-b-0 font-prata">
          <StaggeredText staggerChildren={0.03} delay={0.1}>
            {"We can't wait to meet you!"}
          </StaggeredText>
        </TypographyH2>
      </div>
    </SectionBase>
  );
}

export default GetInTouchSection;
